
import Vue from 'vue'
import ListCellState from './ListCellState.vue'
import ListCellNextAction from './ListCellNextAction.vue'
import { plzMap, plzDistance } from '../helpers/plz'
export default Vue.extend({
    components: {ListCellState, ListCellNextAction},
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        distanceTo: {
            type: Object as any,
            default: () => ({}) as any
        },
        listId: {
            type: String
        },
        allowSelection: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        onClick() {
            this.$router.push({
                name: 'entry',
                params: {
                    id: this.item.id
                }
            })
        }
    },
    computed: {
        classes(): any {
            return {
                'cursor-pointer': true,
                'text-grey': !this.item.isInList
            }
        },
        plzName() {
            return plzMap[this.item.postcode] ? plzMap[this.item.postcode].name : ''
        },
        distance() {
            if(!this.distanceTo || !this.distanceTo.plz) return null
            return Math.round(plzDistance(this.item.postcode, this.distanceTo.plz)/10 * 1.1)*10
        }
    }
})
